// extracted by mini-css-extract-plugin
export default {"header":"MobilePageLayout_header__TIOpZ","content":"MobilePageLayout_content__OjDDF","wrapper":"MobilePageLayout_wrapper__p9mg7"};